import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { RouterService } from '@core/services/router.service';

import { Breadcrumb, BreadcrumbsService } from '../../services/breadcrumbs.service';
import { YButton } from '../y-button/y-button';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'yt-breadcrumbs',
  templateUrl: './breadcrumbs.html',
  styleUrls: ['./breadcrumbs.scss'],
  imports: [YButton, TranslateModule],
  standalone: true,
  host: {
    '[class.show]': 'show()'
  }
})
export class Breadcrumbs {
  private readonly routerService = inject(RouterService);
  private readonly breadcrumbsService = inject(BreadcrumbsService);

  readonly breadcrumbs = this.breadcrumbsService.breadcrumbs;
  readonly hideBreadcrumbs = this.breadcrumbsService.hideBreadcrumbs;
  readonly show = computed(() => !this.hideBreadcrumbs() && !!(this.breadcrumbs().length > 1));

  goTo(breadcrumb: Breadcrumb) {
    let navParts: string[] = [];
    for (let leadingBreadcrumb of this.breadcrumbs()) {
      navParts = [...navParts, leadingBreadcrumb.path];
      if (leadingBreadcrumb.path === breadcrumb.path) {
        break;
      }
    }

    this.routerService.navigate(navParts);
  }
}
